export const HEADER_SIZE = 64;
export const CONTAINER_PAD_SIZE = 24 * 2;
export const NAVIGATION_SIDEBAR_WIDTH = "248px";
export const NAVIGATION_SIDEBAR_COLLAPSED_WIDTH = "64px";

export const CSS_100VH = "var(--vh,1vh) * 100";
export const CALC_100VH = "calc(var(--vh,1vh) * 100)";
